import { ICreateAccountProps } from './app/create-account';
import { AutoCompleteOption } from './components/ui/form/input/autocomplete';

function parse<T>(env: any, parse: (a: any) => T, def?: T): T {
  // @ts-expect-error
  return env ? parse(env) : def;
}

const d = (hour: number, minutes = 0) => new Date(1970, 0, 1, hour, minutes, 0).toISOString();

export const IS_BINARY = parse(import.meta.env.VITE_IS_BINARY_BUILD, Boolean, false);
export const CRYPTO_SECRET_KEY = parse(import.meta.env.VITE_CRYPTO_KEY, String, 'cargill');
export const API_BASE_URL = parse(import.meta.env.VITE_API_BASE_URL, String, 'http://localhost:23193');
export const API_CORE_BASE_URL = parse(import.meta.env.VITE_API_CORE_BASE_URL, String, 'http://localhost:23292');
export const WS_BASE_URL = parse(import.meta.env.VITE_WS_BASE_URL, String, 'ws://localhost:23292/ws');
export const IS_PROD = parse(import.meta.env.PROD, Boolean, false);
export const GMAPS_API_KEY = parse(
  import.meta.env.VITE_GMAPS_API_KEY,
  String,
  'AIzaSyAgC04cD-igXteLnuUcdEzDko2C_xLpKoc'
);

export const FARM_DAY = 'farm-day';

export const VITE_SENTRY_DSN = parse(import.meta.env.VITE_SENTRY_DSN, String);
export const VITE_FDM_ENV = parse(import.meta.env.VITE_FDM_ENV, String, 'local');
export const VITE_FDM_VERSION = parse(import.meta.env.VITE_FDM_VERSION, String, 'latest');

export const FEED_FARM_DAY_KEY = 'FEED:farm-day';
export const FEED_AUTH_KEY = 'FEED:auth';
export const FEED_SESSION = 'FEED:current-session';
export const FEED_SESSION_OFFLINE = 'FEED:current-session-offline';
export const FEED_BINARY_CONFIG = 'FEED:binary-config';
export const FEED_OFFLINE_MODE = 'FEED:offline-mode';
export const FEED_OFFLINE_MODE_TOKEN = 'active';
export const FEED_ZOOM_LEVEL = 'FEED:zoom-level';
/** Linha do Feed Link que a fila está processando agora. Quem escreve são os logs; os dois drawers leem. */
export const FEED_LINK_PROCESSING = 'FEED:LINK_PROCESSING';
export const FEED_REMEMBER_ME = 'FEED:remember-me';
export const FEED_CREATE_ACCOUNT = 'FEED:create-account';
export const FEED_MANAGEMENT_SORT_TYPE = 'FEED:management-sort-type';
export const FEED_TRACT_SORT_TYPE = 'FEED:tract-sort-type';
export const FEED_BATCH_REPORT_SORT_TYPE = 'FEED:batch-report-sort-type';
export const FEED_UPDATE_AVAILABLE = 'FEED:update-available';
export const FEED_UPDATE_PROGRESS = 'FEED:update-progress';
export const FEED_UPDATE_SUCCESS = 'FEED:update-success';
export const FEED_UPDATE_ERROR = 'FEED:update-error';
export const FEED_TREAT_FEEDER_ID = 'FEED:treat-feeder-id';
export const FEED_UNTRACEABILITY = 'FEED:UNTRACEABILITY';
export const FEED_APP_CONFIG = 'FEED:app-config';

export enum EnumOfflineMode {
  active = 'active',
  synced = 'synced',
  syncing = 'syncing'
}

export function generateToken(length: number): string {
  const byteLength = Math.ceil((length * 3) / 4);
  const randomBytes = new Uint8Array(byteLength);
  window.crypto.getRandomValues(randomBytes);
  const token = btoa(String.fromCharCode.apply(null, Array.from(randomBytes)));

  return token.substring(0, length);
}

export const FEED_BINARY_CONFIG_DEFAULT = {
  pgUser: 'postgres',
  pgDatabase: 'postgres',
  pgPassword: 'postgres',
  pgHost: '127.0.0.1',
  pgPort: '5432',
  pgParams: '?',
  pgPath: '',
  error: false
};

export const FEED_UNTRACEABILITY_DEFAULT = {
  managementId: null,
  mode: null,
  owner: null
};

export enum Sessions {
  admin = 'Painel',
  reports = 'Relatórios',
  management = 'Manejo',
  tract = 'Trato',
  diet = 'Dieta',
  financial = 'Financeiro',
  traceability = 'Rastreabilidade',
  farm = 'Fazenda',
  medicalServices = 'Sanidade',
  logout = 'Sair',
  batches = 'Lotes avulsos'
}

export const RESPONSIVE_LAYOUT_STORAGE = 'FEED:responsive-layout-v2';

export const commonResponsiveLayout = {
  md: [
    { i: 'A1', x: 0, y: 0, w: 2, h: 18, minW: 2, minH: 9 },
    { i: 'A2', x: 2, y: 0, w: 2, h: 18, minW: 2, minH: 9 },
    { i: 'A3', x: 4, y: 0, w: 2, h: 18, minW: 2, minH: 9 },
    { i: 'A4', x: 6, y: 0, w: 2, h: 18, minW: 2, minH: 18 },
    { i: 'A5', x: 4, y: 1, w: 4, h: 15, minH: 15 },
    { i: 'A6', x: 0, y: 1, w: 4, h: 15, minH: 15 },
    { i: 'A7', x: 0, y: 3, w: 8, h: 24, minH: 24 }
  ],
  xxs: [
    { i: 'A1', x: 0, y: 0, w: 0.5, h: 10 },
    { i: 'A2', x: 1, y: 0, w: 0.5, h: 10 },
    { i: 'A3', x: 0, y: 0, w: 0.5, h: 10 },
    { i: 'A4', x: 1, y: 0, w: 0.5, h: 10 },
    { i: 'A5', x: 0, y: 1, w: 4, h: 10 },
    { i: 'A6', x: 0, y: 2, w: 4, h: 10 },
    { i: 'A7', x: 0, y: 2, w: 4, h: 24, minH: 24 }
  ]
};

export const GradeMethodValues = {
  P6: -2,
  P5: -1.5,
  P4: -1,
  P3: -0.5,
  P2: -0.25,
  P1: 0,
  P0: 0.25,
  N1: 0.5,
  N2: 1,
  N3: 1.5,
  N4: 2,
  N5: 2.5
};

export const NIGHTLY_OPTIONS = [
  { label: '18:00', value: d(18) },
  { label: '19:00', value: d(19) },
  { label: '20:00', value: d(20) },
  { label: '21:00', value: d(21) },
  { label: '22:00', value: d(22) },
  { label: '23:00', value: d(23) },
  { label: '00:00', value: d(0) },
  { label: '01:00', value: d(1) },
  { label: '02:00', value: d(2) },
  { label: '03:00', value: d(3) },
  { label: '04:00', value: d(4) }
];

export const MATINAL_OPTIONS = [
  { label: '05:00', value: d(5) },
  { label: '06:00', value: d(6) },
  { label: '07:00', value: d(7) },
  { label: '08:00', value: d(8) },
  { label: '09:00', value: d(9) },
  { label: '10:00', value: d(10) },
  { label: '11:00', value: d(11) },
  { label: '12:00', value: d(12) }
];

export const GRADE_OPTIONS = [
  { id: 6, value: '-2.00', label: 'Nota 6 (-2.00 Kg)' },
  { id: 5, value: '-1.50', label: 'Nota 5 (-1.50 Kg)' },
  { id: 4, value: '-1.00', label: 'Nota 4 (-1 Kg)' },
  { id: 3, value: '-0.50', label: 'Nota 3 (-0.50 Kg)' },
  { id: 2, value: '-0.25', label: 'Nota 2 (-0.25 Kg)' },
  { id: 1, value: '0.00', label: 'Nota 1 (0 Kg)' },
  { id: 0, value: '0.25', label: 'Nota 0 (0.25 Kg)' },
  { id: -1, value: '0.50', label: 'Nota -1 (0.50 Kg)' },
  { id: -2, value: '1.00', label: 'Nota -2 (1.00 Kg)' },
  { id: -3, value: '1.50', label: 'Nota -3 (1.50 Kg)' },
  { id: -4, value: '2.00', label: 'Nota -4 (2.00 Kg)' },
  { id: -5, value: '2.50', label: 'Nota -5 (2.5 Kg)' }
];

export const CARGILL_OPTIONS = [
  { value: 'DRY', label: 'DRY' },
  { value: 'CRUMB', label: 'CRUMBS' },
  { value: 'INVENTORY', label: 'INVENTORY' }
];

export const TREAT_SCHEDULE_OPTIONS: AutoCompleteOption[] = [
  { label: '05:00', value: d(5) },
  { label: '06:00', value: d(6) },
  { label: '07:00', value: d(7) },
  { label: '08:00', value: d(8) },
  { label: '09:00', value: d(9) },
  { label: '10:00', value: d(10) },
  { label: '11:00', value: d(11) },
  { label: '12:00', value: d(12) },
  { label: '13:00', value: d(13) },
  { label: '14:00', value: d(14) },
  { label: '15:00', value: d(15) },
  { label: '16:00', value: d(16) },
  { label: '17:00', value: d(17) },
  { label: '18:00', value: d(18) },
  { label: '19:00', value: d(19) },
  { label: '20:00', value: d(20) }
];

export const CREATE_ACCOUNT_DEFAULT: ICreateAccountProps = {
  step1: null,
  step2: null,
  step3: null,
  step4: null,
  step5: null
};

export const getGradeOptions = (data: any) => {
  if (!data || typeof data !== 'object' || Object.keys(data).length === 0) {
    return GRADE_OPTIONS;
  }

  return [
    { id: 6, value: data.p6?.toString(), label: `Nota 6 (${data.p6?.toString()} Kg)` },
    { id: 5, value: data.p5?.toString(), label: `Nota 5 (${data.p5?.toString()} Kg)` },
    { id: 4, value: data.p4?.toString(), label: `Nota 4 (${data.p4?.toString()} Kg)` },
    { id: 3, value: data.p3?.toString(), label: `Nota 3 (${data.p3?.toString()} Kg)` },
    { id: 2, value: data.p2?.toString(), label: `Nota 2 (${data.p2?.toString()} Kg)` },
    { id: 1, value: data.p1?.toString(), label: `Nota 1 (${data.p1?.toString()} Kg)` },
    { id: 0, value: data.p0?.toString(), label: `Nota 0 (${data.p0?.toString()} Kg)` },
    { id: -1, value: data.n1?.toString(), label: `Nota -1 (${data.n1?.toString()} Kg)` },
    { id: -2, value: data.n2?.toString(), label: `Nota -2 (${data.n2?.toString()} Kg)` },
    { id: -3, value: data.n3?.toString(), label: `Nota -3 (${data.n3?.toString()} Kg)` },
    { id: -4, value: data.n4?.toString(), label: `Nota -4 (${data.n4?.toString()} Kg)` },
    { id: -5, value: data.n5?.toString(), label: `Nota -5 (${data.n5?.toString()} Kg)` }
  ];
};

export const macsEnable = ['CE:07:5F:17:E5:33'];

/** Mesmo critério do menu de Moderação: sufixo de e-mail, não lista de contas. */
export const MODERATOR_EMAIL_DOMAINS = ['@kasco.ai', '@cargill.com'] as const;

export function isModeratorEmail(email?: string | null) {
  return !!email && MODERATOR_EMAIL_DOMAINS.some((domain) => email.endsWith(domain));
}

export function isModeratorPath(path: string) {
  return path === '/admin/moderator' || path.startsWith('/admin/moderator/');
}
